import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlertComponent } from './alert.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { ViewAlertComponent } from './view-alert/view-alert.component';
import { MediaComponent } from 'src/app/media/media.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: AlertComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'view-alert/:alertId',
                data: {
                    breadcrumb: 'view-alert'
                },
                component: ViewAlertComponent,
                canActivate: [AuthGuard]
            },
            { 
                path: 'media/:alertId/:compositionId',
                component: MediaComponent
            },
        ]
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlertRoutingModule { }

